/* eslint-disable max-lines */
/* eslint-disable camelcase */
/* eslint-disable max-depth */
/* eslint-disable operator-linebreak */
/* eslint-disable max-statements */
/* eslint-disable no-magic-numbers */

import request from '@/utils/http';

// 查询发车单详情
export const getDispatchLists = (data) => {
    return request({
        url: `/api-tms/dispatch/${data}`,
        method: 'get'
    });
};

// 根据发车单号查询运输单商品明细
export const getSearchdetails = (data) => {
    return request({
        url: `/api-tms/dispatch/searchdetail/${data}`,
        method: 'get'
    });
};

// 根据发车单号查询运输单列表(装货)
export const getSearchtransports = (data) => {
    return request({
        url: `/api-tms/dispatch/searchtransport/sitegroup/${data}`,
        method: 'get'
    });
};

// 根据发车单号查询运输单站点分组列表卸货（卸货）
export const getDischargeCargo = (data) => {
    return request({
        url: `/api-tms/dispatch/searchtransport/sitegroupunload/${data}`,
        method: 'get'
    });
};

// 手工装车(保存)
export const getHandLoadings = (data) => {
    return request({
        url: `/api-tms/dispatch/updateload`,
        method: 'put',
        data
    });
};

// 取消装车
export const getCellHandLoadings = (data) => {
    return request({
        url: `/api-tms/dispatch/cancelload`,
        method: 'put',
        data
    });
};

// 操作日志
export const getOperationLog = (data) => {
    return request({
        url: `/api-tms/dispatch/trace/log`,
        method: 'post',
        data
    });
};

// 发车单行车路径调整
export const getPathAdjustment = (data) => {
    return request({
        url: `/api-tms/dispatch/pathadjustment`,
        method: 'put',
        data
    });
};

// 发车单详情顶部步骤条路由
export const getStepLists = (data) => {
    return request({
        url: `/api-tms/dispatch/route/dispatchstatus/${data}`,
        method: 'get'
    });
};

// 抵达
export const getArriveLists = (data) => {
    return request({
        url: `/api-tms/dispatch/updatehandlearrivedcust`,
        method: 'put',
        data
    });
};

// 批量抵达
export const updatehandlearrivedcust = data => {
    return request({
        url: `/api-antms/receipt/dispatch/updatehandlearrivedcust`,
        method: 'post',
        data
    });
};

// 取消抵达
export const getArriveCellLists = (data) => {
    return request({
        url: `/api-tms/dispatch/updatecancelarrivedcust`,
        method: 'put',
        data
    });
};

// 到车
export const getDispathOrderRegister = (data) => {
    return request({
        url: `/api-tms/dispatch/updatearrivesite`,
        method: 'put',
        data
    });
};

// 取消到车
export const getCancelarrivesite = (data) => {
    return request({
        url: `/api-tms/dispatch/cancelarrivesite`,
        method: 'put',
        data
    });
};

// 最优路径计算
export const getOptimalPathComputation = (data) => {
    return request({
        url: `/api-tms/dispatchData/getSiteBySystem/${data}`,
        method: 'get',
        data
    });
};

// 发车单装卸货列表查询和里程查询(列表)
export const getoptimizationLists = (data) => {
    return request({
        url: `/api-tms/dispatchData/getDataWithTransports/${data}/0`,
        method: 'get'
    });
};

// 发车单装卸货列表查询和里程查询
export const getOptimizationDialogLists = (data) => {
    return request({
        url: `/api-tms/dispatchData/getDataWithTransports/${data}/1`,
        method: 'get'
    });
};

// 装货确认
export const getConfirmations = (data) => {
    return request({
        url: `/api-tms/dispatch/loadconfirm`,
        method: 'put',
        data
    });
};
// 模糊订单装货确认
export const confirmPlanOrder = (data) => {
    return request({
        url: `/api-tms/dispatch/loadconfirmPlanOrder`,
        method: 'put',
        data
    });
};
// 运输单明细删除
export const detailDelete = (data) => {
    return request({
        url: `/api-tms/dispatch/detailDelete`,
        method: 'post',
        data
    });
};

// 发车单状态数据字典接口（用于本地存储）
export const dispatchStatusLists = (data) => {
    return request({
        url: `/api-mdm/mdmDataDictionaryDetails?dictCode=DISPATCH_STATUS`,
        method: 'get',
        data
    });
};

// 是否标识数据字典接口（用于本地存储）
export const isYN = (data) => {
    return request({
        url: `/api-mdm/mdmDataDictionaryDetails?dictCode=YES_OR_NO`,
        method: 'get',
        data
    });
};

// 预约
export const appointment = (data) => {
    return request({
        url: `/api-tms/transports/appointment`,
        method: 'put',
        data
    });
};
// 批量抵达
export const allArrive = (data) => {
    return request({
        url: `/api-tms/transport/batchArrive`,
        method: 'put',
        data
    });
};
